import React, { useState, useEffect, useRef } from 'react';
import Game from './game/Game';
import Map from './map/Map';
import Profile from './profile/Profile';
import Rank from './rank/Rank';
import Levels from './levels/Levels';
import Shop from './shop/Shop';
import HUD from './components/HUD';
import BottomNav from './components/BottomNav';
import { bottomNavConfig } from './appConfig';
import PLAYER from './playerData';
import { createLevel } from './content/levels';

function App() {
  const [refresh, setRefresh] = useState(0);
  const [currentView, setCurrentView] = useState('map');
  const [currentLevel, setCurrentLevel] = useState(1);
  const [showShop, setShowShop] = useState(false);
  
  const app = {
    goToGame: (levelNumber) => {
      setCurrentLevel(levelNumber);
      setRefresh(prev => prev + 1);
      setCurrentView('game');
    },
    goToMap: () => {
      setRefresh(prev => prev + 1);
      setCurrentView('map');
    },
    goToProfile: () => {
      setRefresh(prev => prev + 1);
      setCurrentView('profile');
    },
    goToRank: () => {
      setRefresh(prev => prev + 1);
      setCurrentView('rank');
    },
    goToLevels: () => {
      setRefresh(prev => prev + 1);
      setCurrentView('levels');
    },
    goToShop: () => {
      setShowShop(true);
    }
  };
  
  const handleGameFinish = (isVictory) => {
    if (isVictory) {
      // Check if this is the first time completing this level
      const isFirstTimeCompletion = !PLAYER.completedLevels.includes(currentLevel);
      
      if (isFirstTimeCompletion) {
        // Add level to completed levels
        PLAYER.completedLevels.push(currentLevel);
        
        // Get level data to determine rewards
        const levelData = createLevel(currentLevel);
        
        // Add rewards to queue if they exist
        if (levelData.rewards) {
          PLAYER.rewardQueue.push({
            stars: levelData.rewards.stars,
            gold: levelData.rewards.gold,
            timestamp: Date.now()
          });
        }
      }
    }
    
    // Return to map
    app.goToMap();
  };
  
  // Get the list of screen IDs from bottomNavConfig
  const bottomNavScreenIds = bottomNavConfig.screens.map(screen => screen.id);
  
  return (
    <div className="h-full w-full mx-auto flex flex-col">
      <HUD />
      <div className="flex-1 min-h-0">
        {currentView === 'game' ? (
          <Game 
            levelNumber={currentLevel}
            app={app}
            onGameFinish={handleGameFinish}
            key={refresh}
          />
        ) : currentView === 'profile' ? (
          <Profile 
            app={app}
            key={refresh}
          />
        ) : currentView === 'rank' ? (
          <Rank 
            app={app}
            key={refresh}
          />
        ) : currentView === 'levels' ? (
          <Levels
            app={app}
            key={refresh}
          />
        ) : (
          <Map
            app={app}
            key={refresh}
          />
        )}
      </div>
      {bottomNavScreenIds.includes(currentView) && <BottomNav app={app} />}
      
      <Shop isOpen={showShop} onClose={() => setShowShop(false)} />
    </div>
  );
}

export default App;
